var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"c-close-button"},_vm.$listeners),[_c('span',{staticClass:"c-bar"}),_c('span',{staticClass:"c-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }